import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Actions } from '@ngrx/effects';
import { Store } from "@ngrx/store";
import { AppState } from "../../../../app.reducer";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RenameFolder } from '../_store/resources.actions';
import { ValidationUtil, VALIDATION_MESSAGES } from 'src/app/utils/validation.util';


@Component({
  selector: 'app-rename-folder-dialogue',
  templateUrl: './rename-folder-dialogue.component.html',
  styleUrls: ['./rename-folder-dialogue.component.scss']
})
export class RenameFolderDialogueComponent implements OnInit {

  renameFolderForm: FormGroup;
  folderObj;
  validationMsg = VALIDATION_MESSAGES;
  constructor(
    public dialogRef: MatDialogRef<RenameFolderDialogueComponent>,
    public action$: Actions,
    private store: Store<AppState>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
      this.dialogRef.disableClose = true;
      this.folderObj = data.currentFolderObj;
  }

  ngOnInit() {
    this.renameFolderForm = this.fb.group({
        name: ["", Validators.compose([
          Validators.required,
          ValidationUtil.cannotBeBlank,
        ])]
    });

    this.renameFolderForm.patchValue({
      name :  this.folderObj.name
    });

  }

  renameFolder(){
    if (this.renameFolderForm.invalid) {
        return false;
    }
    const folderId = this.folderObj.folderId;
    const folderName = this.renameFolderForm.value.name;
    const payload = {
      name: folderName
    };
    this.store.dispatch(new RenameFolder(this.folderObj, payload));

    this.onNoClick();
  }

  onNoClick(){
    this.dialogRef.close();
  }

}
